const BASIC_PAGINATED_FIELDS = {};
const ALL_PAGINATED_FIELDS = {
    edges: {
        cursor: 'all',
        node: 'all',
    },
    nodes: 'all',
    pageInfo: {
        endCursor: 'all',
        hasNextPage: 'all',
    },
    totalCount: 'all',
};
export function paginatedGQLFields(fields, innerGQLFieldsFn) {
    if (fields === 'basic')
        fields = BASIC_PAGINATED_FIELDS;
    if (fields === 'all')
        fields = ALL_PAGINATED_FIELDS;
    return `
  __typename
  ${fields.edges
        ? `
    edges {
      ${fields.edges.cursor
            ? `
        cursor
      `
            : ``}
      ${fields.edges.node
            ? `
        node {
          ${innerGQLFieldsFn(fields.edges.node)}
        }
      `
            : ``}
    }
  `
        : ``}
  ${fields.nodes
        ? `
    nodes {
      ${innerGQLFieldsFn(fields.nodes)}
    }
  `
        : ``}
  totalCount
  pageInfo {
      endCursor
      hasNextPage
  }
  `;
}
